import { Component, HostBinding, OnInit } from '@angular/core'
import { UserState } from '@app/shared/store/user/user.state'
import { Select } from '@ngxs/store'
import { Observable } from 'rxjs'

@Component({
	selector: 'app-base-sidenav',
	templateUrl: './base-sidenav.component.html',
	styleUrls: ['./base-sidenav.component.scss'],
})
export class BaseSidenavComponent implements OnInit {
	@Select(UserState.initials) public userInitials$!: Observable<string>
	public isExpanded: boolean = false

	@HostBinding('class.is--expanded')
	get _isExpanded(): boolean {
		return this.isExpanded
	}

	constructor() {}

	ngOnInit(): void {}

	public toggleSidenav(): void {
		this.isExpanded = !this.isExpanded
	}

	public showUserInfo(): void {
		console.log('showUserInfo not yet implemented')
	}
}
